import {materials} from "./materials";

export const informMaterials = [
    {
        id: 1,
        materials: materials,
        menuItemId: 1
    },
]